import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const auth = useSelector((state) => state.auth);

  if (auth.loading) {
    return <div>Loading...</div>;
  }

  return auth.token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
